<script lang="ts" setup>
  import * as locales from '@nuxt/ui/locale'

  // Idioma
  const { locale, setLocale, availableLocales } = useI18n()
  
  // Filtrar locales de Nuxt UI para mostrar solo los configurados en i18n
  const filteredLocales = computed(() => {
    const order = new Map(LOCALE_CODES.map((code, index) => [code, index]))
    return Object.values(locales)
      .filter((loc) => isLocaleCode(loc.code) && availableLocales.includes(loc.code))
      .sort((a, b) => (order.get(a.code as LocaleCode) ?? 0) - (order.get(b.code as LocaleCode) ?? 0))
  })

  const handleLocaleChange = async (newLocale: string | undefined) => {
    if (!newLocale || !isLocaleCode(newLocale)) return
    await setLocale(newLocale)
  }
</script>

<template>
  <ULocaleSelect
    :model-value="locale"
    :locales="filteredLocales"
    @update:model-value="handleLocaleChange"
  />
</template>